import { uid } from "@xbs/lib-state";
export function setPrioritySelectedTasks({ store, priority }) {
    const selected = store.getState().selected;
    if (!selected.length)
        return;
    priority = priority === "null" || priority == "0" ? null : +priority;
    let $meta;
    if (selected.length > 1) {
        $meta = { batch: uid() };
    }
    store.eachSelected((id) => {
        const task = store.getTask(id);
        store.in.exec("update-task", {
            id,
            task: {
                ...task,
                priority,
            },
            $meta,
        });
    });
}
//# sourceMappingURL=priority.js.map